import type { IntlShape } from 'react-intl';
import { StreamingSource } from 'fym-shared/src/music24/streaming';
import { formatDay } from '../streamingFormat';
import { streamingStateMessages as messages } from '../streamingStateMessages';

function isSameUtcDay(left: Date, right: Date): boolean {
  return left.toISOString().slice(0, 10) === right.toISOString().slice(0, 10);
}

/** The state line of a source card (design f1). */
export function sourceStateText(intl: IntlShape, source: StreamingSource, now: Date = new Date()): string {
  switch (source.state) {
    case 'firstRead':
      return intl.formatMessage(messages.cardFirstRead);
    case 'reconnect':
      return source.stoppedAt === null
        ? intl.formatMessage(messages.cardSignedOutNoDate)
        : intl.formatMessage(messages.cardSignedOut, { date: formatDay(intl, source.stoppedAt) });
    case 'disconnected':
      return source.stoppedAt === null
        ? intl.formatMessage(messages.cardDisconnectedNoDate)
        : intl.formatMessage(messages.cardDisconnected, { date: formatDay(intl, source.stoppedAt) });
    case 'failed':
      return intl.formatMessage(messages.cardFailed);
    case 'noArtist':
      return intl.formatMessage(messages.cardNoArtist);
    case 'ok':
    default: {
      if (source.lastSyncAt === null) {
        return intl.formatMessage(messages.cardWaiting);
      }
      const at = new Date(source.lastSyncAt);
      return isSameUtcDay(at, now)
        ? intl.formatMessage(messages.cardReadToday, { time: intl.formatTime(at, { timeStyle: 'short' }) })
        : intl.formatMessage(messages.cardLastRead, { date: formatDay(intl, source.lastSyncAt.slice(0, 10)) });
    }
  }
}
